<script>
import { defineComponent } from 'vue';
import vueNumberInput from '@chenfengyuan/vue-number-input';
import Incrementer from '@/helpers/increment.js';

export default defineComponent({
    name: 'returnMaterialModal',
    setup() {},
    data() {
        return {
            openDialog: false,
            qtyToReturn: 0,
        }
    },
    components: {
        vueNumberInput
    },
    methods: {
        closeDialog() {
            this.$store.commit('consignment/setReturnItem', null)
            this.$store.commit('consignment/setReturnPO', null)
        }
    },
    computed: {
        returnItem() {
            return this.$store.getters['consignment/returnItem'];
        },
        item() {
            try {
                return this.used.filter(i => i.itemNumber==this.returnItem)[0];
            }catch(e) {return {}}
        },
        returnPO() {
            return this.$store.getters['consignment/returnPO'];
        },
        used() {
            return this.$store.getters['consignment/used'];
        },
        accessToken() {
            return this.$store.getters['auth/accessToken']
        },
        defaultIncrement() {
            return Incrementer.DefaultCutLength(this.returnItem, this.item.quantityUnitOfMeasure)
        },
        user() {
            return this.$store.getters['auth/user'];
        }
    },
    watch: {
        returnItem() {
            this.returnItem != null ? this.openDialog = true : this.openDialog = false;
        },
        item() {
            try {
                this.qtyToReturn = parseInt(this.item.quantityUsed);
            }catch(e) {return;}
            
        }
    }
})
</script>

<template>
    <div>
        <q-dialog v-model="openDialog" square :no-esc-dismiss=true :no-backdrop-dismiss=true :dense=true>
            <q-card class="WCWContainer" style="height: auto;padding:0;">
                <q-card-section class="text-center q-pa-none q-ma-none">
                    <div class="row" style="display: table; width: 100%;">
                        <h2 class="wcwBlue">Return Material</h2>
                        <span>
                            <q-btn class="absolute absolute-right" icon="close" flat round dense @click="closeDialog()" v-close-popup />
                        </span>
                    </div>
                </q-card-section>
                <q-card-section class="text-center q-pt-none q-ma-none">
                        <span class="text-left block">Return Single Item:</span>
                        <span class="text-left block bold q-mb-sm"><strong>Item: {{returnItem}}</strong> </span>
                        <vue-number-input v-model="qtyToReturn" :model-value="parseInt(item.quantityUsed)" :min="defaultIncrement" :max="parseInt(item.quantityUsed)" :step="defaultIncrement" :inputtable="user.customerConsignmentCutsAllowed"  size="small" @input="onInput" controls center></vue-number-input>
                
                        <div class="q-pa-none q-ma-none">
                            <div class="text-center">
                                <q-btn color="cyan-7" :unelevated=true :ripple=true label="Return Item" class="q-mt-md" @click="$store.dispatch('consignment/returnMaterial', [accessToken, returnItem, qtyToReturn, returnPO]), closeDialog()"/>
                            </div>
                        </div>
                </q-card-section>
                <q-separator />
                
                <!-- PO LIST -->
                <q-card-section class="text-center q-mt-sm q-ma-none">
                    <span class="text-left block">Return All Items on PO:</span>
                    <span class="text-left block bold q-mb-sm"><strong>PO: {{returnPO}}</strong> </span>
                    <div class="q-pa-none q-ma-none">
                        <div class="text-center">
                            <q-btn color="cyan-7" style="width: 124px" :unelevated=true :ripple=true label="Return ALL" class="q-mt-md" @click="$store.dispatch('consignment/returnMaterial', [accessToken, null, null, returnPO]), closeDialog()"/>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>

</template>